import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'manage-services.pricing-action-required.title',
    defaultMessage: 'Action required',
  },
  subtitle: {
    id: 'manage-services.pricing-action-required.subtitle-contact-support',
    defaultMessage: 'Your pricing submission could not be verified. Contact support to resolve it.',
  },
});
